import { ActionIcon, Tooltip } from '@mantine/core';
import { IconLayoutSidebarRight } from '@tabler/icons';
import { useTranslation } from 'react-i18next';
import { DEFAULT_CANVAS_TITLE, useChatStore } from '@mygpt/app/chat';
import { useMedia } from '@mygpt/app/utils';

export const CanvasToggleButton = ({
  messageId,
  canvas_url,
  canvas_title,
}: {
  messageId: string;
  canvas_url?: string;
  canvas_title?: string;
}) => {
  const { shownCanvas, setShownCanvas, clearShownCanvas, removeShownCanvas, addShownCanvas } = useChatStore();
  const { t } = useTranslation();
  const isCanvasOpened = Object.keys(shownCanvas).length > 0;
  const { isMobile } = useMedia();

  if (!canvas_url) return null;

  return (
    <Tooltip label={t('canvas.toggle')} withArrow>
      <ActionIcon
        variant="subtle"
        onClick={() => {
          // 如果点击了相同的canvas, 则关闭canvas
          if (isCanvasOpened && shownCanvas[messageId]) {
            if (isMobile) {
              removeShownCanvas(messageId);
            } else {
              clearShownCanvas();
            }
            return;
          }

          // 如果点击了不同的canvas, 则展示新的canvas
          if (isMobile) {
            addShownCanvas(messageId, canvas_url, canvas_title || DEFAULT_CANVAS_TITLE);
          } else {
            setShownCanvas(messageId, canvas_url, canvas_title || DEFAULT_CANVAS_TITLE);
          }
        }}
      >
        <IconLayoutSidebarRight color="gray" />
      </ActionIcon>
    </Tooltip>
  );
};
